import React from "react";
import { Route } from "react-router-dom";
import { ErrorBoundary } from "./ErrorBoundary";

export const ErrorHandledRoute = ({ path, component: Component, render, children }) => (
  <Route path={path}>
    <ErrorBoundary withMessage={true}>{children || (render ? render() : <Component />)}</ErrorBoundary>
  </Route>
);
